/**
 * Formats points according to the user's requirements:
 * - Whole numbers are shown without decimals (e.g., 199 -> "199")
 * - Decimals are shown only when necessary, excluding trailing zeros (e.g., 0.9 -> "0.9")
 */
export const formatPoints = (amount: number): string => {
  // Number() with toFixed() and toString() handles this naturally:
  // - 199.00 becomes "199"
  // - 0.90 becomes "0.9"
  // - 0.95 becomes "0.95"
  return Number(amount.toFixed(2)).toString();
};
